
import MyJobs from "../components/user/jobs/MyJobs";
import UserLayout from "../components/UserLayout";

const MyJobPage = () => {
    return (
        <UserLayout>
            <MyJobs />
        </UserLayout>
    );
}

export default MyJobPage;